import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { verifyEmailToken } from "@/lib/identity/identity-api";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (searchParams.get("verified") === "1") {
      setStatus("success");
      setMessage("Email verified.");
      return;
    }
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }
    verifyEmailToken(token)
      .then((res) => {
        setStatus("success");
        setMessage(res.message || "Email verified.");
        setTimeout(() => navigate("/login?verified=1"), 2000);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.error || "Verification failed.");
      });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-24" data-testid="verify-email-page">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle>
            {status === "loading" ? "Verifying…" : status === "success" ? "Email verified" : "Verification failed"}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {status === "loading" ? (
            <Loader2 className="w-6 h-6 animate-spin text-primary mx-auto" />
          ) : (
            <>
              <p className="text-muted-foreground text-sm">{message}</p>
              <Link to="/login" className="text-primary text-sm mt-4 inline-block">
                Sign in
              </Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
